<template>
    <ion-item lines="none">
        <ion-slides pager ref="slides">
            <ion-slide>
                <big-stepper size="medium" label="Box Number" v-model="plan.number" @enter="nextSlide()" />
            </ion-slide>
            <ion-slide>
                <big-stepper :max="unboxed" size="medium" label="Items in box" v-model="plan.item_quantity" />
                <small>
                    <ion-text color="danger" v-if="unboxed - plan.item_quantity > 0">
                        {{ unboxed - plan.item_quantity }} unboxed
                    </ion-text>
                </small>
            </ion-slide>
        </ion-slides>
    </ion-item>
</template>

<script>
import {IonItem, IonSlides, IonSlide, IonText} from '@ionic/vue';
import BigStepper from "@/components/BigStepper";
import {computed} from "vue";

export default {
    name: "SingleBoxPlan",
    emits: ['update:modelValue'],
    props: ['modelValue', 'unboxed'],
    components: {
        IonItem,
        BigStepper,
        IonSlides,
        IonSlide,
        IonText
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const plan = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit('update:modelValue', value);
            }
        });
        return {plan};
    },
    methods: {
        async nextSlide() {
            this.$refs['multi'].$el.slideNext();
        }
    }
}
</script>

<style scoped>
    ion-slide {
        display:block;
    }
    .swiper-container {
        padding-bottom: 2em;
    }
</style>
